import { BuilderService } from "./BuilderService";
import { LoaderService } from "./LoaderService";

import { Scene } from "three";

let loader: LoaderService;
let builder: BuilderService;

const scene = new Scene();

function initialize(): void {
    loader = new LoaderService(scene);
    builder = new BuilderService();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any)["builder"] = builder;
}

function destroy(): void {
    loader = undefined!;
    builder = undefined!;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete (window as any)["builder"];
}

export { builder, loader, initialize, destroy };
